
import { createContext, useEffect, useState } from "react";

export const ThemeContext = createContext();

const setCookie = (name, value, days = 365) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
};
const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
};
const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
};

const isNightTime = () => {
  const hour = new Date().getHours();
  return hour >= 22 || hour < 6;
};

export const ThemeProvider = ({ children }) => {

  const [consent, setConsent] = useState(getCookie("cookieConsent"));

  const savedTheme = getCookie("theme");

  const defaultTheme = savedTheme || (isNightTime() ? "night" : "day");

  const [theme, setTheme] = useState(defaultTheme);

  const [showModal, setShowModal] = useState(!savedTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  const handleSelectTheme = (selectedTheme) => {
      setTheme(selectedTheme);
      setCookie("theme", selectedTheme);
      setShowModal(false);
  };

  const acceptCookies = () => {
    setCookie("cookieConsent", "accepted");
    setConsent("accepted");
    setShowModal(false);
  };

  const declineCookies = () => {
    setCookie("cookieConsent", "declined", 30);
    setConsent("declined");
    setShowModal(true);
  };

  const toggleTheme = () => {
    handleSelectTheme(theme === "day" ? "night" : "day");
  };

  return (
    <ThemeContext.Provider
      value={{
        theme,
        setTheme,
        toggleTheme,
        showModal,
        setShowModal,
        handleSelectTheme,
        consent,
        setConsent,
        acceptCookies,
        declineCookies,
      }}
    >
      { children }
    </ThemeContext.Provider>
  );
};
